<template>
  <SbEmptyOptions>
    <!-- @slot slot to render empty actions list -->
    <slot />
  </SbEmptyOptions>
</template>

<script>
import SbEmptyOptions from '@src/components/ActionList/components/SbEmptyOptions.vue';

export default {
  name: 'SbEmptyActions',
  components: {
    SbEmptyOptions,
  },
};
</script>
